import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-info-box',
  templateUrl: './info-box.component.html',
  styleUrls: ['./info-box.component.scss'],
})
export class InfoBoxComponent {
  @Input() information!: string;
  @Output() downloadEvent = new EventEmitter();
  onDownload = () => this.downloadEvent.emit();
}
